import { render, staticRenderFns } from "./pilgrimage.vue?vue&type=template&id=c6feea38&"
import script from "./pilgrimage.vue?vue&type=script&lang=js&"
export * from "./pilgrimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports